import React from "react";
import classNames from "classnames";
import { keys } from '../../utils';
import styles from "./Checkbox.module.scss";
import { Error } from "./FormFieldInputNew";

const keyChecker = (e, method) => {
    if (e.keyCode === keys.enter || e.keyCode === keys.space) {
        method()
    }
}

const CheckboxImage = ({ changeValue, ariaLabel, checked }) => {
    return <svg role="checkbox" aria-label={ariaLabel} aria-checked={checked} tabIndex={0} onKeyDown={e => keyChecker(e, changeValue)} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="16" height="16" className={styles['bg']} />
        <rect x="0.5" y="0.5" width="15" height="15" rx="1.5" className={styles['border']} />
        <path
            d="M2.59996 7.57717C2.26787 7.9118 2.26787 8.45165 2.59996 8.78628L5.57564 11.7848C5.96677 12.1789 6.60411 12.1789 6.99524 11.7848L13.4005 5.3304C13.7327 4.99566 13.7336 4.45593 13.4026 4.12V4.12C13.0663 3.77872 12.5161 3.77774 12.1786 4.11782L6.28544 10.0562L3.81749 7.57631C3.48165 7.23885 2.93532 7.23924 2.59996 7.57717V7.57717Z"
            stroke="none" className={styles['check']} />
    </svg>
}

const PartialImage = ({ changeValue, ariaLabel, checked }) => {
    return <svg role="checkbox" aria-label={ariaLabel} aria-checked={checked} tabIndex={0} onKeyDown={e => keyChecker(e, changeValue)} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.5" y="0.5" width="15" height="15" rx="1.5" className={styles['bg']} />
        <rect x="3" y="7" width="10" height="2" rx="1" className={styles['check']} />
        <rect x="0.5" y="0.5" width="15" height="15" rx="1.5" className={styles['border']} />
    </svg>
}

export default React.memo(({ form, isPartial, name, value, style, onChange: _onChange, checked: _checked, disabled, className, children, showError: _showError, ariaLabel, hideErrorMessage, errorStyle, ...rest }) => {
    let onChange = _onChange;
    let checked = _checked;
    let showError = _showError;
    if (form && name) {
        checked = checked || form.formState[name];
        onChange = onChange || form.handleFormChange;
        if (!_showError) {
            showError = (form.submissionAttempted || (form.dirty[name])) && form.formErrors[name]
        }
    }

    const Image = isPartial ? PartialImage : CheckboxImage;

    return <label className={classNames(styles["base"], className, { [styles["disabled"]]: disabled, [styles["active"]]: checked || isPartial, [styles["error"]]: showError })} style={style}>
        <input checked={checked} onChange={onChange} readOnly={!onChange} type="checkbox" name={name} value={value === undefined ? name : value} disabled={disabled} {...rest} />
        <Image changeValue={onChange} ariaLabel={ariaLabel} checked={checked} />
        {children}
        <Error showError={showError && !hideErrorMessage} errorMessage={showError} errorStyle={errorStyle} />
    </label>
});